const ChartToolTipBody = {
    name: 'ChartToolTipBody',
    props: {}
};
export default ChartToolTipBody;
